import { render, staticRenderFns } from "./detail3.vue?vue&type=template&id=1b804bea&scoped=true&"
import script from "./detail3.vue?vue&type=script&lang=ts&"
export * from "./detail3.vue?vue&type=script&lang=ts&"
import style0 from "./detail3.vue?vue&type=style&index=0&id=1b804bea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b804bea",
  null
  
)

export default component.exports